export default "__VITE_ASSET__BP_$UaZn__"